import { render } from "./PatientAuthorizedContactsRow.vue?vue&type=template&id=3eb92b0c&ts=true"
import script from "./PatientAuthorizedContactsRow.ts?vue&type=script&lang=ts&external"
export * from "./PatientAuthorizedContactsRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__